import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * Availability Schema
 * Per-Player RSVP for a game OR a team event (exactly one of `game`/
 * `teamEvent` — enforced in the controller, never via schema defaults).
 * Upsert-only: changing your answer overwrites the doc, there is no delete
 * path (which is what keeps the partial unique indexes safe from soft-delete
 * interactions). `user` records who answered (the player's linked account).
 */
export const AvailabilitySchema = z.object({
  _id: objectId,
  divisionTeam: objectId,
  game: objectId.optional(),
  teamEvent: objectId.optional(),
  player: objectId,
  user: objectId.optional(),
  status: z.enum(['yes', 'no', 'maybe']),
  note: z.string().max(200).optional(),
  ...timestampFields,
});

export type Availability = z.infer<typeof AvailabilitySchema>;

export const availabilityMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  divisionTeam: { ref: 'DivisionTeam', label: 'Team' },
  game: { ref: 'Game', label: 'Game' },
  teamEvent: { ref: 'TeamEvent', label: 'Event' },
  player: { ref: 'Player', label: 'Player' },
  user: { ref: 'User', label: 'Answered By' },
  status: { label: 'Status' },
  note: { label: 'Note' },
  created: { hidden: true },
  updated: { hidden: true },
};
